import { createReducer } from "./utils";

import {
    handleAvailable,
    handleRequest,
    handleUnavailable
} from '../reducerHandlers';

import {
    PRODUCTS_STATES_AVAILABLE,
    PRODUCTS_STATES_REQUEST,
    PRODUCTS_STATES_UNAVAILABLE,
    SNACK_SET,
} from './constants';

const defaultState = {
    productsStates: [],
    loadingProductsStates: false,
    stockCategories: [],
    loadingStockCategories: false,
    lastProductSources: [],
    loadingLastProductSources: false,
    productsStatesLegacy: [],
    loadingProductsStatesLegacy: false,
}

export const reducer = createReducer(defaultState, {
    [PRODUCTS_STATES_REQUEST]: handleRequest,
    [PRODUCTS_STATES_AVAILABLE]: handleAvailable,
    [PRODUCTS_STATES_UNAVAILABLE]: handleUnavailable,
});

export function getProductsStatesLegacy(store, supplier_ids, categories, products_status) {
    return async (dispatch, _, { services: { dataSource } }) => {
        const loadingName = 'loadingProductsStatesLegacy'
        const keyState = 'productsStatesLegacy'

        dispatch({ type: PRODUCTS_STATES_REQUEST, payload: { loadingName } });
        try {
            const productsStatesResponse = await dataSource.getProductsStatusLegacy(store, supplier_ids, categories, products_status);
            const productsState = productsStatesResponse?.data ?? [];
            dispatch({
                type: PRODUCTS_STATES_AVAILABLE,
                payload: { data: productsState, keyState, loadingName },
            });
        } catch (error) {
            console.log('error getProductsStatesLegacy: ', error);
            dispatch({
                type: PRODUCTS_STATES_UNAVAILABLE,
                payload: { error, keyState, loadingName },
            });
            const snack = {
                open: true,
                message: 'There was an error getting the products states',
                severity: 'error',
            };
            dispatch({ type: SNACK_SET, payload: { snack } });
        }
    };
}

export function getProductsStates(store, supplier_ids, categories, availability_states = [], availability_source = [], stock_categories = [], product_status = []) {
    return async (dispatch, _, { services: { dataSource } }) => {
        const loadingName = 'loadingProductsStates'
        const keyState = 'productsStates'

        dispatch({ type: PRODUCTS_STATES_REQUEST, payload: { loadingName } });
        try {
            const productsStatesResponse = await dataSource.getProductsStatus(store, supplier_ids, categories, availability_states, stock_categories, availability_source, product_status);
            const productsState = productsStatesResponse?.data ?? [];
            dispatch({
                type: PRODUCTS_STATES_AVAILABLE,
                payload: { data: productsState, keyState, loadingName },
            });
        } catch (error) {
            console.log('error: ', error);
            dispatch({
                type: PRODUCTS_STATES_UNAVAILABLE,
                payload: { error, keyState, loadingName },
            });
            const snack = {
                open: true,
                message: 'There was an error getting the products states',
                severity: 'error',
            };
            dispatch({ type: SNACK_SET, payload: { snack } });
        }
    };
}

export function getStockCategories(t) {
    return async (dispatch, _, { services: { dataSource } }) => {
        const loadingName = 'loadingStockCategories'
        const keyState = 'stockCategories'

        dispatch({ type: PRODUCTS_STATES_REQUEST, payload: { loadingName } });
        try {
            const response = await dataSource.getStockCategories();
            const stockCategories = (response?.stock_categories ?? []).map(category => ({
                stock_name: t(`cws_app.general.${category.key_name}`, category.default_key_name),
                stock_cube_id: category.stock_cube_id
            }));
            dispatch({
                type: PRODUCTS_STATES_AVAILABLE,
                payload: { data: stockCategories, keyState, loadingName },
            });
        } catch (error) {
            console.log('error: ', error);
            dispatch({
                type: PRODUCTS_STATES_UNAVAILABLE,
                payload: { error, keyState, loadingName },
            });
            const snack = {
                open: true,
                message: 'There was an error getting the stock categories',
                severity: 'error',
            };
            dispatch({ type: SNACK_SET, payload: { snack } });
        }
    };
}

export function getLastProductSources(t) {
    return async (dispatch, _, { services: { dataSource } }) => {
        const loadingName = 'loadingLastProductSources'
        const keyState = 'lastProductSources'

        dispatch({ type: PRODUCTS_STATES_REQUEST, payload: { loadingName } });
        try {
            const response = await dataSource.getLastProductSources();
            const lastProductSources = (response?.data_sources ?? []).map(source => ({
                source_name: t(`cws_app.general.${source.key_name}`, source.default_key_name),
                source_cube_id: source.source_cube_id
            }));
            dispatch({
                type: PRODUCTS_STATES_AVAILABLE,
                payload: { data: lastProductSources, keyState, loadingName },
            });
        } catch (error) {
            console.log('error: ', error);
            dispatch({
                type: PRODUCTS_STATES_UNAVAILABLE,
                payload: { error, keyState, loadingName },
            });
            const snack = {
                open: true,
                message: 'There was an error getting the last product sources',
                severity: 'error',
            };
            dispatch({ type: SNACK_SET, payload: { snack } });
        }
    };
}

export function getProductStatusOptions(t) {
    return async (dispatch, _, { services: { dataSource } }) => {
        const loadingName = 'loadingProductStatusOptions'
        const keyState = 'productStatusOptions'

        dispatch({ type: PRODUCTS_STATES_REQUEST, payload: { loadingName } });
        try {
            const response = await dataSource.getProductStatusOptions();
            const productStatusOptions = (response?.product_status_options ?? []).map(status => ({
                status_name: t(`cws_app.general.${status.key_name}`, status.default_key_name),
                status_cube_id: status.status_cube_id
            }));
            dispatch({
                type: PRODUCTS_STATES_AVAILABLE,
                payload: { data: productStatusOptions, keyState, loadingName },
            });
        } catch (error) {
            console.log('error: ', error);
            dispatch({
                type: PRODUCTS_STATES_UNAVAILABLE,
                payload: { error, keyState, loadingName },
            });
            const snack = {
                open: true,
                message: 'There was an error getting the product status options',
                severity: 'error',
            };
            dispatch({ type: SNACK_SET, payload: { snack } });
        }
    };
}
